import React from 'react'
import PropTypes from 'prop-types'

import theme from '../../../styles/theme'

const SvgHome = ({ color, ...other }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...other}>
            <path
                fill="none"
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth="2"
                d="M32 3L2 33h9v30h12V47h16v16h12V33h11z"
            />
        </svg>
    )
}

SvgHome.defaultProps = {
    color: theme.palette.primary.light,
}

SvgHome.propTypes = {
    color: PropTypes.string,
}

export default SvgHome
